import { render, staticRenderFns } from "./service-settings.vue?vue&type=template&id=8e752926"
import script from "./service-settings.vue?vue&type=script&lang=js"
export * from "./service-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports